import type { DailySalesSummary } from "../models/DailySalesSummary";
import type { KeyValue } from "../models/KeyValue";
import { CreateCrudService } from "./CrudServiceFactory";
export function ReportService() {
  return CreateCrudService<DailySalesSummary, KeyValue>({
    Route: "report",
    EntityName: "Report",
    PartialFields: ["Code", "BusinessDate"],
    LoadingMessage: "Loading daily sales summaries...",
    SavingMessage: "Saving report...",
  });
}
